import { useEffect, useState } from "react";
import { Navigate } from "react-router-dom";

export const ProtectedRoute = ({ children }) => {
  const [isCodeValid, setIsCodeValid] = useState(true);

 useEffect(() => {
   const gameTime = localStorage.getItem("gameEnd");

   if (!gameTime) {
     setIsCodeValid(true);
     return;
   }

   const gameTimeDate = new Date(gameTime);
   const now = new Date();
   const timeDiffInMinutes = (now - gameTimeDate) / 1000 / 60;

   if (timeDiffInMinutes <= 2) {
     setIsCodeValid(true);
   } else {
     // ❌ Expired – clean up localStorage
     localStorage.removeItem("gameEnd");
     setIsCodeValid(false);
   }
 }, []);

  // ❌ Redirect if code is invalid or expired
  if (!isCodeValid) {
    return <Navigate to="/" />;
  }

  // ✅ Otherwise, allow access
  return children;
};
